import { Container, Stack, Typography } from "@mui/material";
import React from "react";
import logo from "./Media/mashawirilogo.png";
import and from "./Media/android.jpeg";
import ios from "./Media/ios.png";
import insta from "./Media/instagram.png";
import face from "./Media/facebook.png";
import twitt from "./Media/twitter.png";
import whats from "./Media/whatsapp.png";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function () {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleClick = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };

  return (
    <div style={{ backgroundColor: "white" }}>
      <Container>
        <Stack sx={{ alignContent: "center", alignItems: "center" }}>
          <img
            alt="logo96"
            src={logo}
            style={{ width: "250px", objectFit: "cover", cursor: "pointer" }}
            onClick={handleClick}
          />
        </Stack>

        <Stack
          direction="row"
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Stack direction="column">
            <Typography sx={{ color: "gray", fontWeight: "bold" }}>
              Android for client
            </Typography>
            <br />
            <a href="https://play.google.com/store/apps/details?id=com.ma.ma_app_client">
              <img src={and} style={{ width: "60%", borderRadius: "10px" }} />
            </a>
          </Stack>
          <Stack direction="column">
            <Typography sx={{ color: "gray", fontWeight: "bold" }}>
              Android for driver
            </Typography>
            <br />
            <a href="https://play.google.com/store/apps/details?id=com.ma.ma_app_driver">
              <img src={and} style={{ width: "60%", borderRadius: "10px" }} />
            </a>
          </Stack>
          <Stack direction="column">
            <Typography sx={{ color: "gray", fontWeight: "bold" }}>
              ios for client
            </Typography>
            <br />
            <a href="https://play.google.com/store/apps/details?id=com.ma.ma_app_driver">
              <img
                alt="img2532"
                src={ios}
                style={{ width: "60%", borderRadius: "10px" }}
              />
            </a>
          </Stack>
          <Stack direction="column">
            <Typography sx={{ color: "gray", fontWeight: "bold" }}>
              ios for driver
            </Typography>
            <br />
            <a href="https://play.google.com/store/apps/details?id=com.ma.ma_app_driver">
              <img
                alt="img8655"
                src={ios}
                style={{ width: "60%", borderRadius: "10px" }}
              />
            </a>
          </Stack>
        </Stack>
        <br />
        <br />
        <Container>
          <Stack
            direction="row"
            gap={10}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "gray", fontSize: "12px" }}>
              {t("Designed By")}{" "}
              <a href="https://focustradingcompany.com/">
                Focus Trading Company
              </a>
            </Typography>

            <Typography sx={{ color: "gray", fontSize: "14px" }}>
              {t("© 2023 , All Rights reserved")}
            </Typography>
          </Stack>
          <br />

          <Stack
            direction="row"
            gap={3}
            sx={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <a href="https://instagram.com/mashawiri811?igshid=MzRlODBiNWFlZA==">
              <img alt="858582" src={insta} style={{ width: "30px" }} />
            </a>
            <a href="http://www.facebook.com/Mashawiri1">
              <img alt="9658img" src={face} style={{ width: "30px" }} />
            </a>
            <a href="https://wa.me/message/DVOCE4QSQ4SDJ1">
              <img alt="img765825" src={whats} style={{ width: "30px" }} />
            </a>
            <a href="https://twitter.com/Mashawiri159148">
              <img alt="img565165" src={twitt} style={{ width: "30px" }} />
            </a>
          </Stack>
        </Container>
      </Container>
      <br />
    </div>
  );
}
